import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Packages } from './components/Packages';
import { Portfolio } from './components/Portfolio';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/live/PurchaseToast';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-white" data-id="element-0" data-mp="31c9ygdv1bhw7">
      <Navbar data-id="element-1" data-mp="2wk06ksad07ra" />
      <main data-id="element-2" data-mp="2wjgpfdsj9neb">
        <Hero data-id="element-3" data-mp="2wiyxuugtfxcq" />
        <Packages data-id="element-4" data-mp="2wj8evsjvuu6a" />
        <Portfolio data-id="element-5" data-mp="2wip36tktt20p" />
        <Process data-id="element-6" data-mp="28ufpkexrnkkn" />
        <Testimonials data-id="element-7" data-mp="28tw6guwdqq51" />
        <Faq data-id="element-8" data-mp="28te2fc3h77mk" />
        <FinalCta data-id="element-9" data-mp="28suu8n3mnxlq" />
      </main>
      <Footer data-id="element-10" data-mp="28s2zfehuu3wi" />
      <PurchaseToast data-id="element-11" data-mp="23vkw8j26adma" />
    </div>;
}